import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';

import posterDefault from './assets/images/poster.png';
import bgDefaultVideo from './assets/video/bgVideo.webm';
import { useVote } from './hooks/useVote';
import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import Quiz from './components/Quiz/Quiz';
import { Winners } from './components/Winners/Winners';

function App() {
  const { voteState, currentState, voteActivity: isVisible } = useVote();
  const { winners, speed } = useCarousel();

  const {
    questionFontSize,
    varNumFontSize,
    answerFontSize,
    bgVideo,
    bgPoster,

    title,
    qrCode1,
    qrCode2,
    titreHeight,
  } = useGetParams();

  const advt_info = useMemo(
    () => ({
      qrCode1: qrCode1,
      qrCode2: qrCode2,
      label: title,
    }),
    [title, qrCode1, qrCode2],
  );

  return (
    <div
      className="app-wrapper"
      style={{ '--height': titreHeight, '--speed': `${speed}ms` }}
    >
      <AnimatePresence>
        {isVisible && ['S1', 'S2'].includes(currentState) && (
          <motion.div
            key={'advt' + voteState?.id}
            style={{ width: '100%' }}
            initial={{ translateX: 0, opacity: 0, flex: 1 }}
            animate={{ translateX: 0, opacity: 1, flex: 1 }}
            exit={{ translateX: '-200vw', opacity: 0, flex: 1 }}
            transition={{ duration: 1 }}
          >
            <AdvtFullSize currentState={currentState} advtInfo={advt_info} />
          </motion.div>
        )}
        {isVisible && ['S1', 'S2'].includes(currentState) && (
          <motion.div
            key={'quiz' + voteState?.id}
            style={{ width: '100%' }}
            initial={{ translateX: 0, opacity: 0, flex: 1 }}
            animate={{ translateX: 0, opacity: 1, flex: 1 }}
            exit={{ translateX: '-200vw', opacity: 0, flex: 1 }}
            transition={{ duration: 1, flex: 1 }}
          >
            <Quiz
              questionFontSize={questionFontSize}
              varNumFontSize={varNumFontSize}
              answerFontSize={answerFontSize}
              questionImgUrl={voteState?.questionImgUrl}
              title={voteState?.title}
              currentState={currentState}
              variants={voteState?.vars}
            />
          </motion.div>
        )}
        {isVisible && currentState === 'S3' && (
          <motion.div
            key={'winners' + voteState?.id}
            style={{ width: '100%' }}
            initial={{ translateX: 0, opacity: 0 }}
            animate={{ translateX: 0, opacity: 1 }}
            exit={{ translateX: '-200vw', opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <Winners winnerMessages={winners || []} />
          </motion.div>
        )}
      </AnimatePresence>

      {bgVideo && (
        <video
          playsInline
          autoPlay="autoplay"
          muted="muted"
          loop
          poster={bgVideo === '1' ? posterDefault : bgPoster}
          id="bgVideo"
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          ></source>
        </video>
      )}
      <div id="img-loader" />
    </div>
  );
}

export default App;
